import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export function setToken(token) {
  if (token) {
    localStorage.setItem("aura_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("aura_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function loadToken() {
  const t = localStorage.getItem("aura_token");
  if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  return t;
}

export function fileUrl(fid) {
  // Legacy fallback for callers with only the id. Prefer signed URLs returned by API responses.
  const t = localStorage.getItem("aura_token") || "";
  return `${API_BASE}/files/${fid}?auth=${encodeURIComponent(t)}`;
}

// Absolute-ize a backend-relative signed URL (e.g. "/api/files/abc?sig=...").
export function absUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u}`;
}

export async function streamChat({ conversation_id, text, file_ids, web_search }, onToken, onDone, onError) {
  const token = localStorage.getItem("aura_token");
  const r = await fetch(`${API_BASE}/chat/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ conversation_id, text, file_ids, web_search }),
  });
  if (!r.ok || !r.body) {
    const err = await r.text().catch(() => "");
    onError && onError(err || `HTTP ${r.status}`);
    return;
  }
  const reader = r.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const e of events) {
      const lines = e.split("\n");
      const evLine = lines.find((l) => l.startsWith("event:"));
      const dataLine = lines.find((l) => l.startsWith("data:"));
      if (!dataLine) continue;
      let payload = {};
      try { payload = JSON.parse(dataLine.slice(5).trim()); } catch {}
      const ev = evLine ? evLine.slice(6).trim() : "token";
      if (ev === "token") onToken && onToken(payload.text || "");
      else if (ev === "done") onDone && onDone(payload);
      else if (ev === "error") onError && onError(payload.message || "error");
    }
  }
}
